"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Searchbar = _interopRequireDefault(require("../Searchbar/Searchbar"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _makeStyles["default"])(function (theme) {
  return {
    wrapper: {
      position: "relative",
      width: "100%",
      overflow: "hidden"
    },
    root: function root(props) {
      return _defineProperty({
        position: "relative",
        display: "flex",
        alignItems: "end",
        paddingBottom: 125,
        justifyContent: "center",
        overflow: "hidden",
        height: 620,
        width: "100%",
        backgroundImage: "".concat(props.backgroundImage ? "url(".concat(props.backgroundImage, ")") : theme.palette.background["default"]),
        backgroundSize: "cover",
        "&:before": {
          content: "''",
          zIndex: 0,
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          background: "linear-gradient(to bottom, rgba(0,0,0,0.25) 0%, rgba(0,0,0,0.35) 7% 90%, rgba(0,0,0,0) 100%)"
        }
      }, theme.breakpoints.down('sm'), {
        height: "auto",
        paddingTop: 70,
        paddingBottom: 55
      });
    },
    bg: {
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundSize: "cover"
    },
    inner: function inner(props) {
      return {
        position: "relative",
        width: theme.breakpoints.values.lg,
        maxWidth: "100%",
        paddingLeft: 24,
        paddingRight: 24
      };
    },
    searchWrapper: _defineProperty({
      marginTop: 70
    }, theme.breakpoints.down('sm'), {
      display: "none"
    }),
    searchWrapperMb: _defineProperty({
      paddingLeft: 24,
      paddingRight: 24,
      transform: "translateY(-50px)",
      marginBottom: -40
    }, theme.breakpoints.up("sm"), {
      display: "none"
    }),
    heading: _defineProperty({
      textTransform: "uppercase",
      fontSize: 65,
      fontWeight: 600,
      lineHeight: 1.2,
      marginBottom: 8
    }, theme.breakpoints.down('sm'), {
      fontSize: 50
    }),
    subHeading: _defineProperty({
      fontSize: 30,
      fontWeight: 600,
      lineHeight: 1.2,
      marginBottom: 24
    }, theme.breakpoints.down('sm'), {
      fontSize: 24
    }),
    text: {
      color: theme.palette.common.white,
      textShadow: "0 3px 5px rgba(0,0,0,0.2)",
      "& .highlight": {
        position: "relative",
        display: "inline-block",
        "&:before": {
          content: "''",
          position: "absolute",
          top: -2,
          bottom: -2,
          left: -6,
          right: -6,
          background: theme.palette.primary.main,
          borderRadius: 20
        },
        "& > span": {
          position: "relative",
          paddingLeft: 10,
          paddingRight: 10
        }
      }
    }
  };
});
function HomeHero(_ref2) {
  var children = _ref2.children,
    backgroundImage = _ref2.backgroundImage,
    title = _ref2.title,
    subTitle = _ref2.subTitle,
    locations = _ref2.locations,
    boatTypes = _ref2.boatTypes,
    onSearch = _ref2.onSearch,
    isMobile = _ref2.isMobile,
    location = _ref2.location,
    setLocation = _ref2.setLocation,
    selectedBoatTypes = _ref2.selectedBoatTypes,
    setSelectedBoatTypes = _ref2.setSelectedBoatTypes,
    maxPrice = _ref2.maxPrice,
    setMaxPrice = _ref2.setMaxPrice,
    capacity = _ref2.capacity,
    setCapacity = _ref2.setCapacity,
    searchBoxItems = _ref2.searchBoxItems,
    boatLowestPrice = _ref2.boatLowestPrice,
    currency = _ref2.currency;
  var _useStyles = useStyles({
      backgroundImage: backgroundImage
    }),
    wrapper = _useStyles.wrapper,
    root = _useStyles.root,
    bg = _useStyles.bg,
    text = _useStyles.text,
    heading = _useStyles.heading,
    subHeading = _useStyles.subHeading,
    inner = _useStyles.inner,
    searchWrapper = _useStyles.searchWrapper,
    searchWrapperMb = _useStyles.searchWrapperMb;
  var highlightedSubTitle = (0, _react.useMemo)(function () {
    return (subTitle || "").replace("[", '<span class="highlight"><span>').replace("]", "</span></span>");
  }, [subTitle]);
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: wrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bg
  }, _react["default"].Children.map(children, function (child) {
    return /*#__PURE__*/_react["default"].cloneElement(child, {
      className: child.props.className || undefined
    });
  })), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: root
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: inner
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    id: "home-hero-title",
    component: "h1",
    className: (0, _classnames["default"])(text, heading),
    align: "center"
  }, title), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    id: "home-hero-subtitle",
    component: "h2",
    className: (0, _classnames["default"])(text, subHeading),
    align: "center",
    dangerouslySetInnerHTML: {
      __html: highlightedSubTitle
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: searchWrapper
  }, /*#__PURE__*/_react["default"].createElement(_Searchbar["default"], {
    locations: locations,
    boatTypes: boatTypes,
    onSearch: onSearch,
    isMobile: isMobile,
    location: location,
    setLocation: setLocation,
    selectedBoatTypes: selectedBoatTypes,
    setSelectedBoatTypes: setSelectedBoatTypes,
    capacity: capacity,
    setCapacity: setCapacity,
    maxPrice: maxPrice,
    setMaxPrice: setMaxPrice,
    searchBoxItems: searchBoxItems,
    boatLowestPrice: boatLowestPrice,
    currency: currency
  }))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: searchWrapperMb
  }, /*#__PURE__*/_react["default"].createElement(_Searchbar["default"], {
    locations: locations,
    boatTypes: boatTypes,
    onSearch: onSearch,
    isMobile: isMobile,
    location: location,
    setLocation: setLocation,
    selectedBoatTypes: selectedBoatTypes,
    setSelectedBoatTypes: setSelectedBoatTypes,
    capacity: capacity,
    setCapacity: setCapacity,
    maxPrice: maxPrice,
    setMaxPrice: setMaxPrice,
    searchBoxItems: searchBoxItems,
    boatLowestPrice: boatLowestPrice,
    currency: currency
  })));
}
var _default = exports["default"] = HomeHero;